import {
  Qualifier,
  QualifierSegment,
} from "model/Tournament/Segment/Qualifier/Qualifier";
import {
  FsQualifier,
  FsQualifierSegment,
} from "db/model/tournament/Segment/Qualifier/FsQualifier";
import { nonUndefined } from "Utility";
import { mapTournamentSegmentBase } from "../FsTournamentSegment";
import { mapTournamentSegmentGroupBase } from "../FsTournamentSegmentGroup";

export const mapQualifierSegment = (
  fsModel: FsQualifierSegment
): QualifierSegment | undefined => {
  return mapTournamentSegmentBase(fsModel, fsModel.type, mapQualifiers);
};

const mapQualifiers = (fsModels: FsQualifier[]): Qualifier[] => {
  return nonUndefined(fsModels.map(mapQualifier));
};

const mapQualifier = (fsModel: FsQualifier): Qualifier | undefined => {
  if (!fsModel.matchIds) {
    return undefined;
  }

  return {
    ...mapTournamentSegmentGroupBase(fsModel),
    matchIds: fsModel.matchIds,
  };
};
